import {z} from 'zod'

import {
  CreateOrUpdateBlockIntegrationDocument,
  OfficeIntegrationEnum,
} from '@sdox/api'

import {updateMetaSchema} from '../../utils/getUpdateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'

import type {BlockIntegrationInput,
  CreateOrUpdateBlockIntegrationMutation} from '@sdox/api'

export type UpdateIntegrationValidatorSchema = z.infer<typeof updateIntegrationValidatorSchema>

const updateIntegrationValidatorSchema = z.object({
  data: z.object({
    defaultValue: z.string().nullable(),
    integrationType: z.nativeEnum(OfficeIntegrationEnum),
  }),
  meta: updateMetaSchema,
})

export const integrationConfig = createFormConfig<
  UpdateIntegrationValidatorSchema,
  CreateOrUpdateBlockIntegrationMutation,
  BlockIntegrationInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockIntegrationDocument,
  },
  fieldMapper: (fieldValues) => ({
    defaultValue: fieldValues.data.defaultValue,
    integrationType: fieldValues.data.integrationType,
  }),
  validatorSchema: updateIntegrationValidatorSchema,
  inputFields: [
    {
      label: 'Default Value',
      inputType: 'text',
      fieldName: 'data.defaultValue',
      required: false,
      defaultValue: null,
    },
    {
      label: 'Type',
      inputType: 'select',
      fieldName: 'data.integrationType',
      required: true,
      options: [
        {label: OfficeIntegrationEnum.SeatCupraOfficeVCard, value: OfficeIntegrationEnum.SeatCupraOfficeVCard},
        {label: OfficeIntegrationEnum.Instagram, value: OfficeIntegrationEnum.Instagram},
        {
          label: OfficeIntegrationEnum.NwConsumptionValueDisclaimer,
          value: OfficeIntegrationEnum.NwConsumptionValueDisclaimer,
        },
      ],
    },
  ],
})
